
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AchievementStatus = {
  InProgress: 'InProgress',
  Granted: 'Granted'
} as const

export type AchievementStatus = (typeof AchievementStatus)[keyof typeof AchievementStatus]


export const OutboundCampaignStatus = {
  Draft: 'Draft',
  Sending: 'Sending',
  Sent: 'Sent',
  Failed: 'Failed'
} as const

export type OutboundCampaignStatus = (typeof OutboundCampaignStatus)[keyof typeof OutboundCampaignStatus]


export const OutboundCampaignDeliveryStatus = {
  Pending: 'Pending',
  Sent: 'Sent',
  Failed: 'Failed'
} as const

export type OutboundCampaignDeliveryStatus = (typeof OutboundCampaignDeliveryStatus)[keyof typeof OutboundCampaignDeliveryStatus]


export const TestimonialStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected'
} as const

export type TestimonialStatus = (typeof TestimonialStatus)[keyof typeof TestimonialStatus]


export const TeachingService = {
  Private: 'Private',
  Group: 'Group',
  Kids: 'Kids',
  Competitive: 'Competitive',
  Condominium: 'Condominium',
  Gym: 'Gym'
} as const

export type TeachingService = (typeof TeachingService)[keyof typeof TeachingService]


export const TeachingLevel = {
  Beginners: 'Beginners',
  Intermediate: 'Intermediate',
  Advanced: 'Advanced'
} as const

export type TeachingLevel = (typeof TeachingLevel)[keyof typeof TeachingLevel]


export const Sport = {
  Tennis: 'Tennis',
  Squash: 'Squash',
  BeachTennis: 'BeachTennis',
  Padel: 'Padel',
  Pickleball: 'Pickleball'
} as const

export type Sport = (typeof Sport)[keyof typeof Sport]


export const Direction = {
  LeftHanded: 'LeftHanded',
  RightHanded: 'RightHanded',
  Ambidextrous: 'Ambidextrous'
} as const

export type Direction = (typeof Direction)[keyof typeof Direction]


export const Backhand = {
  OneHand: 'OneHand',
  TwoHands: 'TwoHands'
} as const

export type Backhand = (typeof Backhand)[keyof typeof Backhand]


export const MatchStatus = {
  Draft: 'Draft',
  WaitingForCancellation: 'WaitingForCancellation',
  WaitingForPlayers: 'WaitingForPlayers',
  Confirmed: 'Confirmed',
  Finished: 'Finished',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
  Deleted: 'Deleted'
} as const

export type MatchStatus = (typeof MatchStatus)[keyof typeof MatchStatus]


export const MatchType = {
  Singles: 'Singles',
  Doubles: 'Doubles'
} as const

export type MatchType = (typeof MatchType)[keyof typeof MatchType]


export const MatchRankingType = {
  Training: 'Training',
  Ranked: 'Ranked'
} as const

export type MatchRankingType = (typeof MatchRankingType)[keyof typeof MatchRankingType]


export const MatchRankingDeletedBy = {
  OWNER: 'OWNER',
  RANKING_ADMIN: 'RANKING_ADMIN'
} as const

export type MatchRankingDeletedBy = (typeof MatchRankingDeletedBy)[keyof typeof MatchRankingDeletedBy]


export const MatchDuration = {
  HalfHour: 'HalfHour',
  OneHour: 'OneHour',
  OneAndAHalfHours: 'OneAndAHalfHours',
  TwoHours: 'TwoHours',
  MoreThanTwoHours: 'MoreThanTwoHours'
} as const

export type MatchDuration = (typeof MatchDuration)[keyof typeof MatchDuration]


export const MatchCost = {
  MoneyOnly: 'MoneyOnly',
  CheckInOnly: 'CheckInOnly',
  Both: 'Both'
} as const

export type MatchCost = (typeof MatchCost)[keyof typeof MatchCost]


export const Privacy = {
  Public: 'Public',
  ConnectionsOnly: 'ConnectionsOnly',
  InviteLinkOnly: 'InviteLinkOnly'
} as const

export type Privacy = (typeof Privacy)[keyof typeof Privacy]


export const AcceptedGender = {
  MaleOnly: 'MaleOnly',
  FemaleOnly: 'FemaleOnly',
  Both: 'Both'
} as const

export type AcceptedGender = (typeof AcceptedGender)[keyof typeof AcceptedGender]


export const Level = {
  Pro: 'Pro',
  A: 'A',
  BPlus: 'BPlus',
  B: 'B',
  CPlus: 'CPlus',
  C: 'C',
  D: 'D'
} as const

export type Level = (typeof Level)[keyof typeof Level]


export const CourtType = {
  Hard: 'Hard',
  Clay: 'Clay',
  Grass: 'Grass'
} as const

export type CourtType = (typeof CourtType)[keyof typeof CourtType]


export const AllCourtType = {
  Hard: 'Hard',
  Clay: 'Clay',
  Grass: 'Grass',
  Sand: 'Sand'
} as const

export type AllCourtType = (typeof AllCourtType)[keyof typeof AllCourtType]


export const MatchPeriod = {
  Morning: 'Morning',
  Afternoon: 'Afternoon',
  Evening: 'Evening'
} as const

export type MatchPeriod = (typeof MatchPeriod)[keyof typeof MatchPeriod]


export const MatchChallengeStatus = {
  Pending: 'Pending',
  Accepted: 'Accepted',
  CancelledByOwner: 'CancelledByOwner',
  CancelledByChallenger: 'CancelledByChallenger',
  RejectedByMatchOwner: 'RejectedByMatchOwner',
  RejectedByChallenger: 'RejectedByChallenger'
} as const

export type MatchChallengeStatus = (typeof MatchChallengeStatus)[keyof typeof MatchChallengeStatus]


export const Gender = {
  Male: 'Male',
  Female: 'Female'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]


export const InteractionVisibility = {
  Everyone: 'Everyone',
  MaleOnly: 'MaleOnly',
  FemaleOnly: 'FemaleOnly',
  NoOne: 'NoOne'
} as const

export type InteractionVisibility = (typeof InteractionVisibility)[keyof typeof InteractionVisibility]


export const CancellationReason = {
  Wheater: 'Wheater',
  Health: 'Health',
  Attendance: 'Attendance',
  Other: 'Other'
} as const

export type CancellationReason = (typeof CancellationReason)[keyof typeof CancellationReason]


export const RankingType = {
  Platform: 'Platform',
  UserCreated: 'UserCreated'
} as const

export type RankingType = (typeof RankingType)[keyof typeof RankingType]


export const RankingScoringMode = {
  DynamicByPosition: 'DynamicByPosition',
  FixedByConfig: 'FixedByConfig'
} as const

export type RankingScoringMode = (typeof RankingScoringMode)[keyof typeof RankingScoringMode]


export const RankingMatchLimitPeriod = {
  Day: 'Day',
  Week: 'Week',
  Month: 'Month'
} as const

export type RankingMatchLimitPeriod = (typeof RankingMatchLimitPeriod)[keyof typeof RankingMatchLimitPeriod]


export const RankingMatchFormat = {
  AtLeastOneSet: 'AtLeastOneSet',
  OneSetTo6Games: 'OneSetTo6Games',
  OneSetTo9Games: 'OneSetTo9Games',
  BestOf3FullSets: 'BestOf3FullSets',
  BestOf3SuperTiebreak: 'BestOf3SuperTiebreak',
  BestOf5Sets: 'BestOf5Sets'
} as const

export type RankingMatchFormat = (typeof RankingMatchFormat)[keyof typeof RankingMatchFormat]


export const RankingTiebreakCriteria = {
  SetDifference: 'SetDifference',
  GameDifference: 'GameDifference',
  MostGamesWon: 'MostGamesWon',
  MatchDifference: 'MatchDifference',
  SetsWon: 'SetsWon',
  MatchesPlayed: 'MatchesPlayed'
} as const

export type RankingTiebreakCriteria = (typeof RankingTiebreakCriteria)[keyof typeof RankingTiebreakCriteria]


export const RankingScoreRevertReason = {
  MatchCancelled: 'MatchCancelled',
  MatchResultEdited: 'MatchResultEdited',
  RankingUnlinked: 'RankingUnlinked',
  ParticipantRemoved: 'ParticipantRemoved',
  AdminAdjustment: 'AdminAdjustment',
  MatchDeleted: 'MatchDeleted'
} as const

export type RankingScoreRevertReason = (typeof RankingScoreRevertReason)[keyof typeof RankingScoreRevertReason]


export const JoinRequestStatus = {
  Pending: 'Pending',
  Accepted: 'Accepted',
  Rejected: 'Rejected'
} as const

export type JoinRequestStatus = (typeof JoinRequestStatus)[keyof typeof JoinRequestStatus]


export const SurfaceAccessEventKind = {
  dynamic_content_fetch: 'dynamic_content_fetch',
  dynamic_content_web_fetch: 'dynamic_content_web_fetch',
  spotlights_preview_fetch: 'spotlights_preview_fetch',
  spotlights_list_fetch: 'spotlights_list_fetch',
  spotlights_list_page_fetch: 'spotlights_list_page_fetch',
  spotlights_web_list_fetch: 'spotlights_web_list_fetch',
  spotlights_web_list_page_fetch: 'spotlights_web_list_page_fetch',
  app_download_campaign_access: 'app_download_campaign_access'
} as const

export type SurfaceAccessEventKind = (typeof SurfaceAccessEventKind)[keyof typeof SurfaceAccessEventKind]
